var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWalletPrivy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 61,
    viewBox: "0 0 48 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9999 47.2612C37.2527 47.2612 47.9999 36.6794 47.9999 23.6306C47.9999 10.5818 37.2527 0 23.9999 0C10.7471 0 -0.00012207 10.5818 -0.00012207 23.6306C-0.00012207 36.6794 10.7471 47.2612 23.9999 47.2612Z",
    fill: "#010110"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9999 60.9999C33.0575 60.9999 40.4015 59.4781 40.4015 57.6113C40.4015 55.7445 33.0623 54.2227 23.9999 54.2227C14.9375 54.2227 7.59827 55.7445 7.59827 57.6113C7.59827 59.4781 14.9375 60.9999 23.9999 60.9999Z",
    fill: "#010110"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletPrivy);
export default __webpack_public_path__ + "static/media/wallet-privy.6258cc3ef76689aa0b154641be79d32b.svg";
export { ForwardRef as ReactComponent };